/**
 * The language of the portal a rule is saved from. The server writes the alert in it — the readable
 * placeholders, date and number format and its own default texts — so a rule saved in an English portal
 * sends English alerts. There is nobody to ask when an alert goes out: an SMS goes to a number and a mail
 * to an address, so the portal states its language when it saves and the rule keeps it.
 *
 * Only `de` and `en` are sent. Any other portal language leaves the field off, and the server keeps the
 * rule's language as it was (German for a rule that never had one). Like `portalRootURL`, every save
 * restates the language of the portal it comes from.
 *
 * tri-model's class does not carry this field, so it is attached after construction, like the cooldown.
 */
export const alertLanguageOf = (language: string | undefined): 'de' | 'en' | undefined => {
    const base = (language ?? '').trim().toLowerCase().split(/[-_]/)[0];

    return base === 'de' || base === 'en' ? base : undefined;
};

export const withAlertLanguage = <T extends object>(rule: T, language: string | undefined): T & { alertLanguage?: 'de' | 'en' } => {
    const alertLanguage = alertLanguageOf(language);

    return alertLanguage === undefined ? rule : Object.assign(rule, { alertLanguage });
};
